export const sha256Hex = async (str: string) => {
  const normalized = str.trim().toLowerCase();
  const bytes = new TextEncoder().encode(normalized);
  const buffer = await crypto.subtle.digest('SHA-256', bytes);
  const hex = Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
  return hex;
};
